import { Route, PreloadingStrategy } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

export class PreloadSelectedModulesList implements PreloadingStrategy {
  preload(route: Route, load: any): Observable<any> {
    return route.data && route.data.preload ? load() : of(null);
  }
}
